import type { SVGProps } from 'react';
const SvgBurstMode = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#burst_mode_svg__a)">
      <path
        fill="currentColor"
        d="M1 5h2v14H1V5Zm4 0h2v14H5V5Zm17 0H10c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1ZM11 17l2.5-3.15L15.29 16l2.5-3.22L21 17H11Z"
      />
    </g>
    <defs>
      <clipPath id="burst_mode_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgBurstMode;
